module.exports = __webpack_public_path__ + "img/zc.b539b319.png";